import type { ReactNode } from 'react';

interface PanelProps {
  children: ReactNode;
  title?: string;
  action?: ReactNode;
  className?: string;
  noPadding?: boolean;
}

export default function Panel({ children, title, action, className = '', noPadding }: PanelProps) {
  return (
    <div
      className={`rounded-xl ${className}`}
      style={{
        background: 'rgba(17,17,17,0.85)',
        backdropFilter: 'blur(12px) saturate(180%)',
        border: '1px solid rgba(144,185,171,0.08)',
        boxShadow: '0 4px 16px rgba(0,0,0,0.3)',
      }}
    >
      {title && (
        <div className="flex items-center justify-between px-5 py-4"
          style={{ borderBottom: '1px solid var(--border-primary)' }}>
          <h3 className="font-display text-sm" style={{ color: 'var(--text-primary)' }}>
            {title}
          </h3>
          {action}
        </div>
      )}
      <div className={noPadding ? '' : 'p-5'}>
        {children}
      </div>
    </div>
  );
}
